import { render, staticRenderFns } from "./CustomTemplateSizeModal.vue?vue&type=template&id=a8049732"
import script from "./CustomTemplateSizeModal.vue?vue&type=script&lang=js"
export * from "./CustomTemplateSizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8049732')) {
      api.createRecord('a8049732', component.options)
    } else {
      api.reload('a8049732', component.options)
    }
    module.hot.accept("./CustomTemplateSizeModal.vue?vue&type=template&id=a8049732", function () {
      api.rerender('a8049732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/CustomTemplateSizeModal.vue"
export default component.exports